var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessages(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75C7.44365 3.75 3.75 7.44365 3.75 12C3.75 13.0619 3.95027 14.0753 4.31442 15.0057C4.50304 15.4876 4.596 16.0392 4.50106 16.603L3.91458 20.0854L7.39704 19.4989C7.96081 19.404 8.51241 19.497 8.99431 19.6856C9.92468 20.0497 10.9381 20.25 12 20.25C16.5563 20.25 20.25 16.5563 20.25 12C20.25 7.44365 16.5563 3.75 12 3.75ZM2.25 12C2.25 6.61522 6.61522 2.25 12 2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C10.748 21.75 9.54935 21.5136 8.44759 21.0824C8.16576 20.9721 7.89114 20.9369 7.64615 20.9781L3.81731 21.6229C2.96976 21.7657 2.23435 21.0302 2.37708 20.1827L3.02189 16.3539C3.06315 16.1089 3.02791 15.8342 2.9176 15.5524C2.48637 14.4507 2.25 13.252 2.25 12Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 9.99976C7.25 9.58554 7.58579 9.24976 8 9.24976H16C16.4142 9.24976 16.75 9.58554 16.75 9.99976C16.75 10.414 16.4142 10.7498 16 10.7498H8C7.58579 10.7498 7.25 10.414 7.25 9.99976ZM7.25 13.9998C7.25 13.5855 7.58579 13.2498 8 13.2498H12C12.4142 13.2498 12.75 13.5855 12.75 13.9998C12.75 14.414 12.4142 14.7498 12 14.7498H8C7.58579 14.7498 7.25 14.414 7.25 13.9998Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.6ebcccd49110e4d2a64cf092415d9341.svg";
export { ForwardRef as ReactComponent };